__turbopack_context__.v({
  "alt": "AskFigure-module__4YKX6W__alt",
  "caption": "AskFigure-module__4YKX6W__caption",
  "figure": "AskFigure-module__4YKX6W__figure",
});
